import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';

interface TableHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export function TableHeader({children, className}: TableHeaderProps) {
  return (
    <div className={classNames(styles.tableHeader, className)}>{children}</div>
  );
}

export default TableHeader;
